var _0x4364 = ['EMfOwhq=', 'z3jVDxbfBMq=', 'B2jQzwn0', 'u2vLia==', 'BKDQzKK=', 'zNvUy3rPB24=', 'zgf0yq==', 'D1rPsKq=', 'z2v0', 'BgLJzw5Zzuv4CgLYyxrPB25eyxrL', 'DgLTzxn0yw1W', 'y29Kzq==', 'DhLWzq==', 'C2v0', 'DMvYC2LVBG==', 'ChjVzhvJDenVzgvZ', 'u3PgAeu=', 'BMfTzq==', 'sg94tgG=', 'zun0Beq=', 'z3jVDxa=', 'ChjVzhvJDhm=', 'CgfYC2u=', 'BfP2zKS=', 'lcb0AguGCgfJA2fNzsb3yxmGChvIBgLZAgvKig9Uia==', 'Cfj6wKC=', 'tM8GBgLJzw5ZzsbMB3vUzc4k', 'ChjVzhvJDe5HBwu=', 'uwrAy0q=', 'BefHr0m=', 't3jquwq=', 's1Ldrvi=', 'CNvlCgC=', 'AgfZ', 'zxHWAxj5rgf0zq==', 'CgfJA2fNzu5HBwu=', 'y3LqC08=', 'CMr1Aui=', 'CNvHzve=', 'zg9JC1vYBa==', 'uhjVz3jLC3mG', 'ChvIBgLZAerHDgu=', 'vgHLihbYB2r1y3qGAxmGBM90igLUy2X1zgvKigLUihrOzsbSAwnLBNnLlGO=', 'D2fYBG==', 'B3nTvxa=', 'swTrwfO=', 'CLfMrLm=', 'igzVCIbTB3jLigLUzM9YBwf0Aw9UlGO=', 'whv2wMO=', 'rLbJyLa=', 'ww91CIbSAwnLBNnLigv4CgLYzwqGB24G', 'C2nYAxb0s2v5', 'BgLJzw5ZAw5Nrg9JC1vYBa==', 'tgLJzw5ZzsbHy3rPDMf0Aw9UigzHAwXLzcbMB3iG', 'EfbArNi=', 'zMLUza==', 'Dw5KzwzPBMvK', 'Dg9mB2nHBgvtDhjPBMC=', 'BgvUz3rO'];

(function (_0x7861a8, _0x436456) {
  var _0x5c1a2f = function _0x5c1a2f(_0x5bb78a) {
    while (--_0x5bb78a) {
      _0x7861a8['push'](_0x7861a8['shift']());
    }
  };

  _0x5c1a2f(++_0x436456);
})(_0x4364, 0x83);

var _0x5c1a = function _0x5c1a(_0x7861a8, _0x436456) {
  _0x7861a8 = _0x7861a8 - 0x0;
  var _0x5c1a2f = _0x4364[_0x7861a8];

  if (_0x5c1a['eVebMg'] === undefined) {
    var _0x5bb78a = function _0x5bb78a(_0x1df509) {
      var _0x594780 = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789+/=',
          _0x17b0df = String(_0x1df509)['replace'](/=+$/, '');

      var _0x3c70ec = '';

      for (var _0x457d16 = 0x0, _0xa05c9a, _0x1d527d, _0x5817cb = 0x0; _0x1d527d = _0x17b0df['charAt'](_0x5817cb++); ~_0x1d527d && (_0xa05c9a = _0x457d16 % 0x4 ? _0xa05c9a * 0x40 + _0x1d527d : _0x1d527d, _0x457d16++ % 0x4) ? _0x3c70ec += String['fromCharCode'](0xff & _0xa05c9a >> (-0x2 * _0x457d16 & 0x6)) : 0x0) {
        _0x1d527d = _0x594780['indexOf'](_0x1d527d);
      }

      return _0x3c70ec;
    };

    _0x5c1a['JsjtEd'] = function (_0x10b9bf) {
      var _0x16a0de = _0x5bb78a(_0x10b9bf);

      var _0x1c90e4 = [];

      for (var _0x3d01e8 = 0x0, _0x366abb = _0x16a0de['length']; _0x3d01e8 < _0x366abb; _0x3d01e8++) {
        _0x1c90e4 += '%' + ('00' + _0x16a0de['charCodeAt'](_0x3d01e8)['toString'](0x10))['slice'](-0x2);
      }

      return decodeURIComponent(_0x1c90e4);
    }, _0x5c1a['rqrXoU'] = {}, _0x5c1a['eVebMg'] = !![];
  }

  var _0x53878b = _0x5c1a['rqrXoU'][_0x7861a8];
  return _0x53878b === undefined ? (_0x5c1a2f = _0x5c1a['JsjtEd'](_0x5c1a2f), _0x5c1a['rqrXoU'][_0x7861a8] = _0x5c1a2f) : _0x5c1a2f = _0x53878b, _0x5c1a2f;
};

var context = {
  data: '  {\"timestamp\":1634770538,\"products\":[{\"trial\":false,\"code\":\"KENDOUIREACT\",\"licenseExpirationDate\":1650446070},{\"trial\":false,\"code\":\"KENDOUICOMPLETE\",\"licenseExpirationDate\":1650446070},{\"trial\":false,\"code\":\"KENDOUIVUE\",\"licenseExpirationDate\":1650446070},{\"trial\":false,\"code\":\"KENDOUIANGULAR\",\"licenseExpirationDate\":1650446070}],\"integrity\":\"A26ouokUJzS0Y9EDXHAm0qgolAg=\"}  '
},
    cache = new Map();

function setScriptKey(_0x25b2b1) {}

function validatePackage(_0x36c470) {
  if (cache[_0x5c1a('0x14')](_0x36c470[_0x5c1a('0x4')])) {
    if (_0x5c1a('0x35') !== _0x5c1a('0x35')) {
      var _0x43d4c6 = function _0x43d4c6() {
        _0x58c626[_0x5c1a('0x7')](_0x4f3a6b);
      };
    } else return cache[_0x5c1a('0x36')](_0x36c470[_0x5c1a('0x4')]);
  }

  var _0xcadca1 = _0x36c470[_0x5c1a('0x1')] ? '\x20v' + _0x36c470[_0x5c1a('0x1')] : '',
      _0x26985a = _0x36c470[_0x5c1a('0x4')] + _0xcadca1,
      _0x1692a7 = JSON[_0x5c1a('0x9')](context[_0x5c1a('0x34')]),
      _0x7f5683 = !_0x1692a7[_0x5c1a('0x26')] && !_0x1692a7[_0x5c1a('0x38')],
      _0x1309d9 = _0x1692a7[_0x5c1a('0x26')] && typeof KendoLicensing === _0x5c1a('0x2b'),
      _0x1f8788 = matchProduct(_0x1692a7, _0x36c470[_0x5c1a('0x2')]),
      _0x5ed7ca;

  if (_0x7f5683 || _0x1309d9) {
    if (_0x5c1a('0x29') !== _0x5c1a('0x29')) {
      var _0x2f1e7e = function _0x2f1e7e() {
        var _0x388ce5 = _0x5c1a('0x1b') + _0x33655a[_0x5c1a('0xe')],
            _0x3d860e = typeof _0x418368[_0x5c1a('0x7')] === _0x5c1a('0x33');

        _0x3d860e ? _0x3b1deb[_0x5c1a('0x7')](_0x388ce5) : _0x6a3fbd[_0x5c1a('0x1e')](_0x388ce5), _0x523767[_0x5c1a('0x1e')](_0x14b753(_0x322330)), _0x3d860e && _0x1197e0[_0x5c1a('0x2f')]();
      };
    } else _0x5ed7ca = {
      'type': 0x0,
      'packageName': _0x26985a,
      'docsUrl': _0x36c470[_0x5c1a('0x27')]
    };
  } else {
    if (_0x5c1a('0xf') === _0x5c1a('0x24')) {
      var _0x4dfedf = function _0x4dfedf() {
        _0x50b5b8[_0x5c1a('0x37')] < _0xeabda3[_0x5c1a('0x1c')] && (_0x132841 = {
          'type': 0x2,
          'packageName': _0x9f99fc,
          'publishDate': _0x3c1a6b(_0x125dc5[_0x5c1a('0x1c')]),
          'expiryDate': _0x57412b(_0xaf078e[_0x5c1a('0x37')]),
          'docsUrl': _0x49464e[_0x5c1a('0x27')]
        });
      };
    } else {
      if (!_0x1f8788) {
        if (_0x5c1a('0x6') !== _0x5c1a('0x6')) {
          var _0x344115 = function _0x344115() {
            var _0xf14a00 = _0x5222e0[_0x5c1a('0x8')];

            if (!_0xf14a00 || !_0xf14a00[_0x5c1a('0x2d')]) return null;

            var _0x396062 = new _0x5793bd(_0x28cbe8);

            return _0xf14a00[_0x5c1a('0x2a')](function (_0x365d94) {
              return _0x396062[_0x5c1a('0x14')](_0x365d94[_0x5c1a('0x39')]);
            });
          };
        } else _0x5ed7ca = {
          'type': 0x1,
          'packageName': _0x26985a,
          'docsUrl': _0x36c470[_0x5c1a('0x27')]
        };
      } else {
        if (_0x5c1a('0x12') !== _0x5c1a('0x12')) {
          var _0x1776c6 = function _0x1776c6() {
            return null;
          };
        } else {
          if (_0x1f8788[_0x5c1a('0x37')] < _0x36c470[_0x5c1a('0x1c')]) {
            if (_0x5c1a('0x21') === _0x5c1a('0x32')) {
              var _0x1a41c6 = function _0x1a41c6() {
                _0xfaae0d += _0x5c1a('0xd');
              };
            } else _0x5ed7ca = {
              'type': 0x2,
              'packageName': _0x26985a,
              'publishDate': parseDate(_0x36c470[_0x5c1a('0x1c')]),
              'expiryDate': parseDate(_0x1f8788[_0x5c1a('0x37')]),
              'docsUrl': _0x36c470[_0x5c1a('0x27')]
            };
          }
        }
      }
    }
  }

  if (_0x5ed7ca && typeof console === _0x5c1a('0x30')) {
    if (_0x5c1a('0x5') === _0x5c1a('0x3')) {
      var _0x95015b = function _0x95015b() {
        _0x4b786f[_0x5c1a('0x2f')]();
      };
    } else {
      var _0x598f01 = _0x5c1a('0x1b') + _0x36c470[_0x5c1a('0xe')],
          _0x194c9d = typeof console[_0x5c1a('0x7')] === _0x5c1a('0x33');

      if (_0x194c9d) {
        if (_0x5c1a('0xc') !== _0x5c1a('0xc')) {
          var _0x3e7eb6 = function _0x3e7eb6() {
            _0xf344fe[_0x5c1a('0x1e')](_0x141e24);
          };
        } else console[_0x5c1a('0x7')](_0x598f01);
      } else {
        if (_0x5c1a('0x17') !== _0x5c1a('0x17')) {
          var _0x246f1b = function _0x246f1b() {
            var _0x2f1652 = _0x5c1a('0x28') + _0x2644c0[_0x5c1a('0x16')] + '\x0a';

            if (_0x5f5599[_0x5c1a('0x3a')] === 0x2) _0x2f1652 += _0x5c1a('0x25') + _0x24c003[_0x5c1a('0x15')][_0x5c1a('0x2c')]() + _0x5c1a('0xb') + _0x3ad6d6[_0x5c1a('0x1c')][_0x5c1a('0x2c')]() + '.\x0a';else {
              if (_0x5451ba[_0x5c1a('0x3a')] === 0x0) _0x2f1652 += _0x5c1a('0xd');else _0x110ba8[_0x5c1a('0x3a')] === 0x1 && (_0x2f1652 += _0x5c1a('0x1d'));
            }
            return _0x2f1652 += _0x5c1a('0x31') + _0x308c56[_0x5c1a('0x1a')] + _0x5c1a('0x22'), _0x2f1652;
          };
        } else console[_0x5c1a('0x1e')](_0x598f01);
      }

      console[_0x5c1a('0x1e')](formatError(_0x5ed7ca));

      if (_0x194c9d) {
        if (_0x5c1a('0x1f') !== _0x5c1a('0x19')) console[_0x5c1a('0x2f')]();else {
          var _0x188f8b = function _0x188f8b() {
            _0x3d01e8 = {
              'type': 0x0,
              'packageName': _0x366abb,
              'docsUrl': _0x3047b9[_0x5c1a('0x27')]
            };
          };
        }
      }
    }
  }

  var _0xb593c9 = !_0x5ed7ca;

  return cache[_0x5c1a('0x0')](_0x36c470[_0x5c1a('0x4')], _0xb593c9), _0xb593c9;
}

function formatError(_0x1fff02) {
  var _0x2d2f37 = _0x5c1a('0x28') + _0x1fff02[_0x5c1a('0x16')] + '\x0a';

  if (_0x1fff02[_0x5c1a('0x3a')] === 0x2) {
    if (_0x5c1a('0x20') !== _0x5c1a('0x20')) {
      var _0x54c6f4 = function _0x54c6f4() {
        _0x3c1575 = {
          'type': 0x2,
          'packageName': _0x1b19c9,
          'publishDate': _0x573b69(_0x4faf34[_0x5c1a('0x1c')]),
          'expiryDate': _0x183ff8(_0x58364c[_0x5c1a('0x37')]),
          'docsUrl': _0x50a3f6[_0x5c1a('0x27')]
        };
      };
    } else _0x2d2f37 += _0x5c1a('0x25') + _0x1fff02[_0x5c1a('0x15')][_0x5c1a('0x2c')]() + _0x5c1a('0xb') + _0x1fff02[_0x5c1a('0x1c')][_0x5c1a('0x2c')]() + '.\x0a';
  } else {
    if (_0x1fff02[_0x5c1a('0x3a')] === 0x0) {
      if (_0x5c1a('0x13') !== _0x5c1a('0x10')) _0x2d2f37 += _0x5c1a('0xd');else {
        var _0x3af9dd = function _0x3af9dd() {
          _0x2fb0e1 += _0x5c1a('0x25') + _0x3e9e23[_0x5c1a('0x15')][_0x5c1a('0x2c')]() + _0x5c1a('0xb') + _0x4240d2[_0x5c1a('0x1c')][_0x5c1a('0x2c')]() + '.\x0a';
        };
      }
    } else {
      if (_0x1fff02[_0x5c1a('0x3a')] === 0x1) {
        if (_0x5c1a('0x2e') === _0x5c1a('0x23')) {
          var _0x19f89f = function _0x19f89f() {
            !_0xb6e4d ? _0x407247 = {
              'type': 0x1,
              'packageName': _0x2691fa,
              'docsUrl': _0x23e58a[_0x5c1a('0x27')]
            } : _0x2ae2a1[_0x5c1a('0x37')] < _0x378eb4[_0x5c1a('0x1c')] && (_0x39b209 = {
              'type': 0x2,
              'packageName': _0x14e19a,
              'publishDate': _0x3af7fe(_0x38e4e4[_0x5c1a('0x1c')]),
              'expiryDate': _0x2e2e51(_0x2b5bf6[_0x5c1a('0x37')]),
              'docsUrl': _0x27a0c2[_0x5c1a('0x27')]
            });
          };
        } else _0x2d2f37 += _0x5c1a('0x1d');
      }
    }
  }

  return _0x2d2f37 += _0x5c1a('0x31') + _0x1fff02[_0x5c1a('0x1a')] + _0x5c1a('0x22'), _0x2d2f37;
}

function matchProduct(_0x51d9e5, _0x3fff18) {
  var _0x44ef28 = _0x51d9e5[_0x5c1a('0x8')];

  if (!_0x44ef28 || !_0x44ef28[_0x5c1a('0x2d')]) {
    if (_0x5c1a('0x11') !== _0x5c1a('0x11')) {
      var _0x5f109c = function _0x5f109c() {
        _0xc65206 = {
          'type': 0x1,
          'packageName': _0x393daa,
          'docsUrl': _0x33c283[_0x5c1a('0x27')]
        };
      };
    } else return null;
  }

  var _0x11f6ae = new Set(_0x3fff18);

  return _0x44ef28[_0x5c1a('0x2a')](function (_0x590c4a) {
    if (_0x5c1a('0xa') !== _0x5c1a('0x18')) return _0x11f6ae[_0x5c1a('0x14')](_0x590c4a[_0x5c1a('0x39')]);else {
      var _0x295075 = function _0x295075() {
        _0x576540 += _0x5c1a('0x1d');
      };
    }
  });
}

function parseDate(_0x31cf48) {
  return new Date(_0x31cf48 * 0x3e8);
}

export { setScriptKey, validatePackage };